import { AvatarSkin, AvatarEyes, AvatarFeature, AvatarHat, AvatarMouth } from 'src/models/Avatar';

export type StoreItem = {
  id: string;
  name: AvatarSkin | AvatarMouth | AvatarEyes | AvatarHat;
  itemType: AvatarFeature;
  price: number;
  isNew: boolean;
};
